/**
 * discount-top.js
 *
 * Handles:
 *  1. Multi-slide cycling — reads `data-animation-speed` (ms) and cycles slides
 *     using a slide-up / slide-down CSS transition driven by three state classes:
 *       .is-entering  — next slide waiting below (translateY 100%)
 *       .is-active    — currently visible (translateY 0)
 *       .is-exiting   — outgoing slide going up (translateY -100%)
 *
 *  2. Pause on hover — if `[data-pause-on-hover]` is present on the banner,
 *     the interval is cleared on mouseenter and restarted on mouseleave.
 *
 * Note: sticky positioning is now handled by the parent <header> element
 * (position: sticky). The .discount-top--sticky class is retained as a
 * semantic marker for the ACF option but carries no CSS positioning.
 */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    const banner = document.querySelector('[data-banner]');
    if (!banner) return;

    // ----------------------------------------------------------------
    // 1. Multi-slide cycling
    // ----------------------------------------------------------------
    const slides = Array.from(banner.querySelectorAll('.discount-top__slide'));
    if (slides.length < 2) return; // Nothing to animate with 0 or 1 slide

    const TRANSITION_DURATION = 450; // Must match CSS transition duration (ms)
    const animSpeed = parseInt(banner.dataset.animationSpeed, 10) || 4000;
    const pauseOnHover = banner.hasAttribute('data-pause-on-hover');

    let current = 0;
    let interval = null;
    let transitioning = false;

    const goToNext = function () {
      if (transitioning) return;
      transitioning = true;

      const next = (current + 1) % slides.length;

      const currentSlide = slides[current];
      const nextSlide    = slides[next];

      // Stage the incoming slide below the viewport area
      nextSlide.classList.add('is-entering');

      // Force reflow so the initial position is applied before transitioning
      // eslint-disable-next-line no-unused-expressions
      nextSlide.offsetHeight;

      // Begin transitions in the next frame
      requestAnimationFrame(function () {
        currentSlide.classList.add('is-exiting');
        currentSlide.classList.remove('is-active');

        nextSlide.classList.remove('is-entering');
        nextSlide.classList.add('is-active');

        setTimeout(function () {
          currentSlide.classList.remove('is-exiting');
          current = next;
          transitioning = false;
        }, TRANSITION_DURATION);
      });
    };

    const startInterval = function () {
      if (interval) return;
      interval = setInterval(goToNext, animSpeed);
    };

    const stopInterval = function () {
      clearInterval(interval);
      interval = null;
    };

    startInterval();

    // ----------------------------------------------------------------
    // 2. Pause on hover
    // ----------------------------------------------------------------
    if (pauseOnHover) {
      banner.addEventListener('mouseenter', stopInterval);
      banner.addEventListener('mouseleave', startInterval);
    }
  });
}());
